import React from 'react';
import _ from 'lodash';
import copyJSONToBuffer from '../../../../services/mini/copyJSONToBuffer';
import withClickOutsideOnOverlay from '../../../../hoc/withClickOutsideOnOverlay';
import ToasterService from '../../../../services/ToasterService';
import TextFieldWithJsonWrapper from '../../../components/TextFieldWithJsonWrapper/TextFieldWithJsonWrapper';
import VisualStatePlaceholder from '../VisualStatePlaceholder/VisualStatePlaceholder';
import JsonPanelHeader from '../JsonPanel/JsonPanelHeader';
import JsonPanelBody from '../JsonPanel/JsonPanelBody';
import PopupButtons from '../../../components/Popup/PopupButtons';
import PopupButton from '../../../components/Popup/PopupButton';
import PopupCancelButton from '../../../components/Popup/PopupCancelButton';
import JsonPanel from '../JsonPanel/JsonPanel';
import { smartJSONParse } from '../../../../services/mini/isValidJSON';


class AddVisualStateForm extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            visualState: JSON.stringify(this.props.visualState, null, 4) || '',
            error: null,
            visualStateValid: true
        };
    }

    cancel = () => {
        this.props.onClose();
    }

    remove = () => {
        this.props.onRemove();
        this.cancel();
    }

    apply = () => {
        const { visualState, visualStateValid } = this.state;
        let parsedVisualState;
        if (visualState) {

            if (!visualStateValid) {
                return;
            }

            parsedVisualState = smartJSONParse(visualState);
            this.props.onClose();
            this.props.onSave(parsedVisualState);
        }
    }

    clear = () => {
        this.setState({ visualState: '' });
    }

    copy = () => {
        const { visualState } = this.state;
        
        copyJSONToBuffer(visualState);

        ToasterService.showInfo({
            position: 'bottom-left',
            title: 'Copied to clipboard'
        });
    }

    onChange = (value) => {
        this.setState({ visualState: value });
    }

    onValidate = (visualStateValid) => {
        this.setState({ visualStateValid });
    }

    render() {
        const {
            visualState
        } = this.state;
        const {
            onRemove,
            closeLabel,
            saveLabel,
            removeLabel,
        } = this.props;

        const disableApplyBtn = !visualState;

        return (
            <JsonPanel className="add-visual-state-form">
                <JsonPanelHeader
                    title="Visual State"
                    showBtns={true}
                    onClear={this.clear}
                    value={visualState} />
                <JsonPanelBody>
                    <TextFieldWithJsonWrapper
                        value={visualState}
                        placeholder={<VisualStatePlaceholder />}
                        onChange={this.onChange}
                        onValidate={this.onValidate}
                    />
                </JsonPanelBody>
                <PopupButtons>
                    <PopupCancelButton
                        label={closeLabel || "Cancel"}
                        action={this.cancel} />
                    {onRemove &&
                        <PopupButton
                            label={removeLabel || "Remove"}
                            action={this.remove}
                            width={140}
                            className="light-red" />}
                    <PopupButton
                        label={saveLabel || "Apply"}
                        action={this.apply}
                        className={disableApplyBtn && 'disabled'} />
                </PopupButtons>
            </JsonPanel>
        );
    }
}

export default withClickOutsideOnOverlay(AddVisualStateForm);
